import { tokenExpiresAt } from './session-token';

// Entrada usada pelos links de teste do portal. Reutiliza o critério do LoginService;
// a Ajuda estática não é uma autoridade de autenticação. Parâmetro vazio não autentica.
export async function acceptLaunchSession(): Promise<void> {
    const url = new URL(location.href);
    if (!url.searchParams.has('auth_token')) return;
    const token = url.searchParams.get('auth_token') || '';
    url.searchParams.delete('auth_token');
    history.replaceState(history.state, '', url.pathname + url.search + url.hash);
    try {
        if (token.length > 8192 || tokenExpiresAt(token) <= Date.now()) return;
        if (token === localStorage.getItem('auth-token')) return;
        localStorage.setItem('auth-token', token);
        for (const key of ['nomeUsuario', 'emailUsuario', 'roles', 'actions']) localStorage.removeItem(key);
    } catch { /* Armazenamento indisponível mantém o fluxo normal de login. */ }
}
